import React from "react";
import styled from "styled-components";
import { Box, Stack, Typography } from "@mui/material";

const PosterBackground = styled(Stack)`
  && {
    position: fixed;
    top: 0;
    width: 50%;
    height: 100%;
    background: linear-gradient(90deg, #3cf0f1 0%, #03424a 100%);
    border-radius: 0px;
  }
`;

const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 48px;
    line-height: 65px;
    text-align: center;
    color: #ffffff;
  }
`;

function AuthPoster({ PosterImage, forRegisterPage }) {
  return (
    <PosterBackground
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={5}
      sx={{ left: forRegisterPage || "0%" }}
    >
      <Title>Apni company</Title>
      <Box
        component="img"
        src={PosterImage}
        alt=""
        sx={{ width: 490, height: 490 }}
      />
    </PosterBackground>
  );
}

export default AuthPoster;
